function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

import React from 'react';

var SlIcon = function SlIcon(_ref) {
  var iconId = _ref.iconId;
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(iconId)
  }));
};

export { SlIcon };
